module.exports = __webpack_public_path__ + "img/Group 1934@3x.d2ceb70f.png";